module.exports = __webpack_public_path__ + "static/media/info-solid.d428a1ba.svg";